export default function About() {
  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="relative">
          <div className="absolute -top-8 left-0 bg-[#CCFF00] text-[#0A1628] text-xs font-bold px-4 py-2 rounded-full">
            /ABOUT
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center mt-8">
          <div className="lg:col-span-3 bg-[#F0F4F8] rounded-3xl p-12">
            <img 
              src="https://public.readdy.ai/ai/img_res/3a201609-c37c-46ff-b6f2-4ea6229e386e.png" 
              alt="ESVICOL LTDA" 
              className="h-16 w-16 object-contain mb-6"
            />
            
            <h2 className="text-4xl font-bold text-[#0A1628] mb-6">
              ESVICOL LTDA
            </h2>
            
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              Based in Bucaramanga, Colombia, ESVICOL LTDA is a technology company dedicated to developing innovative applications that enhance digital security and user experience. Our flagship product is a cutting-edge VPN service designed to protect your online privacy and provide unrestricted access to the internet.
            </p>
            
            <p className="text-gray-700 text-base leading-relaxed mb-6">
              We believe that everyone deserves the right to browse the internet freely and securely. Our mission is to provide enterprise-grade security solutions that are accessible, reliable, and easy to use for individuals and businesses alike.
            </p>
            
            <div className="space-y-3">
              <p className="text-sm text-gray-600">
                <strong className="text-[#0A1628]">Innovation:</strong> Constantly evolving our technology to stay ahead of digital threats
              </p>
              <p className="text-sm text-gray-600">
                <strong className="text-[#0A1628]">Privacy:</strong> Your data belongs to you, and we keep it that way
              </p>
              <p className="text-sm text-gray-600">
                <strong className="text-[#0A1628]">Reliability:</strong> 99.9% uptime guarantee with 24/7 support
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <img 
                src="https://public.readdy.ai/ai/img_res/c21588b5408940baf7802e7c8913ca2a.jpg" 
                alt="Security Technology" 
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
